export default __webpack_public_path__ + "locales/si/PreparationPortal.json?hash=5e47d63079b9f83d388ba0457a9388af";